import { NotificationDto } from '../../requests/notification/dto';
import { baseAdminURL, baseEmployeeURL, basePortalURL } from '../../routes';
import { isPortalApplication } from '../../utils/common';
import {
  FormattedNotification,
  isApplicationCancelledNotificationDetails,
  isApplicationInvoiceIssuedNotificationDetails,
  isApplicationPendingApprovalNotificationDetails,
  isEmployeeRemainingBalanceUpdatedNotificationDetails,
  isTenantPendingApprovalNotificationDetails,
  isTenantUpdatedNotificationDetails,
} from './types';

export const formatNotificationDetails = (notification: NotificationDto) => {
  const { notificationDetails: details, notificationType: type } = notification;

  const formattedNotification: FormattedNotification = {
    id: notification.id,
    type: type,
    label: `Unknown notification type: ${type}`,
    createdAt: notification.createdAt,
    details,
  };

  const baseLink = isPortalApplication() ? basePortalURL : baseAdminURL;

  if (isEmployeeRemainingBalanceUpdatedNotificationDetails(type, details)) {
    formattedNotification.label = `Your Tech and Home Scheme account has been topped up with an additional £${
      details.amount / 100
    }; access your updated balance to enjoy discounted shopping.`;
    formattedNotification.link = `${baseEmployeeURL}/buy-gift-card`;
  } else if (isApplicationPendingApprovalNotificationDetails(type, details)) {
    formattedNotification.label = `Approve Application #${details.applicationNumber} for ${details.firstName} ${details.lastName}`;
    formattedNotification.link = `${baseLink}/application/view-details/${details.id}`;
  } else if (isApplicationInvoiceIssuedNotificationDetails(type, details)) {
    formattedNotification.label = `Invoice (${details.invoiceNumber}) Sent to ${details.tenantName} for Payment.`;
    formattedNotification.link = `${baseLink}/invoices`;
  } else if (isTenantPendingApprovalNotificationDetails(type, details)) {
    formattedNotification.label = `Employer #${details.accountNumber}`;
    formattedNotification.link = `${baseLink}/tenants/${details.id}`;
  } else if (isApplicationCancelledNotificationDetails(type, details)) {
    formattedNotification.label = `Application (${details.applicationNumber}) has been canceled.`;
    formattedNotification.link = `${baseLink}/applications/${details.id}`;
  } else if (isTenantUpdatedNotificationDetails(type, details)) {
    formattedNotification.label = `Employer (${details.tenant.tenantName}) has updated Tech and Home scheme.`;
  }

  return formattedNotification;
};
